import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EDesktopListingActionType {
  SetVisible = 'DesktopListing/setVisible',
  SetHidden = 'DesktopListing/setHidden',
}

export type TSetListingStateVisibleAction = ITypedReduxAction<EDesktopListingActionType.SetVisible>;
export type TSetListingStateHiddenAction = ITypedReduxAction<EDesktopListingActionType.SetHidden>;

export type TDesktopListingActions = TSetListingStateVisibleAction | TSetListingStateHiddenAction;
